<div class="c-text-title c-text-title-page">File Management</div>

<app-customer-list (newCustomerSelectedEvent)="customerSelected($event)"></app-customer-list>
